import React from "react";

interface WorkshopSession {
  id: number;
  startDateTime: string;
  endDateTime: string;
  eventId: number;
  deleted: boolean;
  createdAt: string;
  updatedAt: string;
}

interface NextSessionDateProps {
  workshopSessions: WorkshopSession[];
}

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
};

const NextSessionDate: React.FC<NextSessionDateProps> = ({ workshopSessions }) => {
  if (!workshopSessions || workshopSessions.length === 0) return <span>-</span>;

  const now = Date.now();

  const upcomingSession = workshopSessions
    .filter((session) => new Date(session.startDateTime).getTime() > now)
    .sort((a, b) => new Date(a.startDateTime).getTime() - new Date(b.startDateTime).getTime())[0];

  const fallbackSession = workshopSessions
    .sort((a, b) => new Date(b.startDateTime).getTime() - new Date(a.startDateTime).getTime())[0];

  return <span>{formatDate(upcomingSession?.startDateTime || fallbackSession?.startDateTime)}</span>;
};

export default NextSessionDate;
